import { makeStyles } from '@material-ui/core';

import { blue, neutral, purple, red, teal, yellow } from 'shared/styles/colors';

export const orderDetailCardStyles = makeStyles(theme => ({
  root: {
    color: neutral.D20,
    borderBottom: `1px solid ${neutral[20]}`,
    marginBottom: '0.75rem',
    '&[data-is-stockout="true"]': {
      border: 'none',
      marginBottom: '0',
    },
  },
  corridor: {
    fontSize: '1rem',
    fontFamily: 'Poppins Bold',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    background: neutral.white,
    padding: '0.75rem',
    '&[data-is-stockout="true"]': {
      [`& [aria-label="quantity"],
      [aria-label="productTitle"],
      [aria-label="detailSubtotal"] *`]: {
        color: neutral[50],
      },
    },
  },
  defectRateBorder: {
    borderLeft: `3px solid ${red[60]}`,
  },
  defectRate: {
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: red[10],
    display: 'flex',
    borderRight: `1px solid ${neutral.D10}`,
    padding: '0.5rem 1rem',
    marginBottom: '0.5rem',
  },
  defectRateIcon: {
    marginRight: '1rem',
    color: yellow.D11,
  },
  defectRateText: {
    fontSize: '0.875rem',
    color: red[60],
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  defectRateCaption: {
    color: neutral[80],
    fontSize: '0.75rem',
    fontWeight: 400,
  },
  defectCheckedRoot: {
    borderRadius: '2px',
    color: neutral.black,
    padding: 0,
  },
  defectChecked: {
    '&.Mui-checked': {
      color: neutral.black,
    },
  },
  container: {
    width: '100%',
    [theme.breakpoints.up('md')]: {},
    fontSize: '1rem',
  },
  quantity: {
    fontSize: '0.875rem',
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: neutral[100],
  },
  detailHeader: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  detailContainer: {
    // borderTop: `1px solid ${neutral.D10}`,
  },
  titleWrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    paddingLeft: '0.5rem',
    width: '100%',
  },
  notes: {
    color: neutral.D15,
    marginBottom: '3px',
  },
  description: {
    paddingBottom: '0.5rem',
    color: neutral[60],
    fontSize: '0.875rem',
    fontWeight: 400,
  },
  productTitle: {
    color: neutral[100],
    fontWeight: 700,
    fontSize: '1rem',
  },
  productPrice: {
    display: 'flex',
  },
  toppings: {
    margin: '0 0 1rem 1.25rem',
  },
  toppingCategory: {
    color: neutral[80],
    fontWeight: 400,
    fontSize: '0.75rem',
  },
  toppingDescription: {
    color: neutral[100],
    fontWeight: 500,
    fontSize: '1rem',
  },
  toppingDetail: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&[data-is-stockout="true"]': {
      '& [aria-label="toppingDetail"], [aria-label="toppingDescription"], [aria-label="toppingPrice"]': {
        color: neutral[50],
      },
    },
  },
  toppingOptions: {
    alignItems: 'center',
    display: 'flex',
    gap: '0.5rem',
  },
  commentWrapper: {
    marginBottom: '20px',
  },
  comments: {
    color: red.D10,
  },
  detailSubtotal: {
    alignItems: 'center',
    gap: '0.5rem',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: neutral.white,
    padding: '0',
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
      padding: '0',
    },
  },
  subtotalVal: {
    color: neutral[100],
    fontSize: '0.875rem',
    fontWeight: 700,
  },
  strikethrough: {
    textDecoration: 'line-through',
  },
  subtotalValLabel: {
    paddingRight: '0.25rem',
    fontWeight: 400,
    color: neutral[60],
  },
  alertMessage: {
    margin: '0 0 0.75rem 0',
  },
  addValue: {
    fontSize: '13px',
    fontFamily: 'Poppins Bold',
    color: teal.D5,
    marginTop: '14px',
    textTransform: 'capitalize',
    padding: '0',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  detailSubtotalKanban: {
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${neutral.D10}`,
    fontSize: '17px',
    [theme.breakpoints.up('md')]: {},
  },
  subtotalValKanban: {
    fontWeight: 600,
  },
  deleteProduct: {
    paddingTop: '0.25rem',
    paddingLeft: '0.5rem',
    borderLeft: `1px solid ${neutral.D11}`,
    cursor: 'pointer',
    marginLeft: '0.5rem',
  },
  deleteProductsDisabled: {
    cursor: 'not-allowed',
  },
  checkProduct: {
    padding: 0,
  },
  checkTopping: {
    padding: 0,
  },
  toppingPrice: {
    fontSize: '0.875rem',
    fontWeight: 400,
    color: neutral[60],
    '&[data-is-stockout="true"]': {
      textDecoration: 'line-through',
    },
  },
  chipDisclaimer: {
    padding: '0.25rem 0.5rem',
  },
  chipText: {
    fontWeight: 500,
  },
  chipDangerIcon: {
    fontSize: '0.75rem',
    color: red[60],
  },
  globalOffer: {
    alignItems: 'center',
    backgroundColor: purple[10],
    display: 'flex',
    borderRight: `1px solid ${neutral.D10}`,
    padding: '0.5rem 1rem',
    marginBottom: '0.5rem',
  },
  globalOfferText: {
    fontSize: '0.875rem',
    color: purple[60],
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  globalOfferCaption: {
    color: neutral[80],
    fontSize: '0.75rem',
    fontWeight: 400,
  },
  globalOfferBorder: {
    borderLeft: `3px solid ${purple[60]}`,
  },
  toppingDisclaimer: {
    alignItems: 'center',
    backgroundColor: blue[10],
    borderLeft: `3px solid ${blue[50]}`,
    display: 'flex',
    padding: '0.5rem 1rem',
    marginBottom: '0.5rem',
    '& > span': {
      color: neutral[80],
      fontSize: '0.75rem',
      fontWeight: 400,
    },
  },
  deleteItemButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));
